import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/fueraDeOficina`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const getPisActivos = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("piActivos"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const getAllOutOfOffice = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("getAll"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const createOutOfOffice = async (data) => {
  const auth = `Bearer ${getToken()}`;
  try {
    let res = await fetch(readUrl("requestFueraDeOficina"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },

      body: JSON.stringify(data),
    });

    res = await parseJSON(res);
    return res.success;
  } catch (error) {
    return error;
  }
};

export const updateOutOfOffice = async (data) => {
  const auth = `Bearer ${getToken()}`;
  try {
    let res = await fetch(readUrl(`updateFueraDeOficina`), {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

export const getOutOfOfficeCatrgories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("categories"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const getTokenOfPiOutOfOffice = async (id) => {
  const auth = `Bearer ${getToken()}`;
  try {
    let res = await fetch(readUrl(`getToken?titular=${id}`), {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};
